import { useNavigate as useReactRouterNavigate } from "react-router";
import { getCurrentLanguageFromUrl } from "../Utils/urlLanguageUtils";

export const useLanguageNavigate = () => {
  const navigate = useReactRouterNavigate();

  const languageNavigate = (path: string, options?: any) => {
    const currentLanguage = getCurrentLanguageFromUrl();

    
    if (path.startsWith("/fa/") || path.startsWith("/en/")) {
      navigate(path, options);
      return;
    }

    
    if (path === "/") {
    
      if (currentLanguage === "fa") {
        navigate("/", options);
      } else {
        navigate(`/${currentLanguage}`, options);
      }
      return;
    }

    
    if (currentLanguage === "fa") {
      navigate(path, options);
    } else {
      const pathWithLanguage = `/${currentLanguage}${path}`;
      navigate(pathWithLanguage, options);
    }
  };

  return languageNavigate;
};

